export default "__VITE_ASSET__DvhT6xAL__"